import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { useLanguage } from "../../context/LanguageContext";
import Cookies from "../../CommonPage/CookiesPage/Cookies";

const Banner = () => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const [flagUrl, setFlagUrl] = useState(""); // fallback
  const { language, translations } = useLanguage();




  const [open, setOpen] = useState(() => {
    // Check localStorage on component mount
    return localStorage.getItem("cookieAccepted") !== "true";
  });
  const handleClose = () => {
    setOpen(false); // ✅ close when clicking icon
  };

  const handleAcceptAll = () => {
    // store consent if needed
    setOpen(false);
  };
  const handleModify = () => {
    console.log("Modify preferences clicked");
  };
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await axios.get("https://ipwhois.app/json/");
        const ipCountryCode = response.data.country; // e.g., 'IN'

        console.log("sdfsdfsdfsa", ipCountryCode);

        setFlagUrl(ipCountryCode);
      } catch (error) {
        console.error("Failed to fetch IP info:", error);
      }
    };

    fetchCountryCode();
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "60vh", sm: "100vh", md: "100vh" },
        overflow: "hidden",
        backgroundColor:'#eff6ff'
      }}
    >
      {/* Background Video */}
      <>
        {isSmall ? (
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              objectFit: "cover",
              zIndex: 0,
            }}
          >
            <source src="https://res.cloudinary.com/dk24unkwu/video/upload/v1753695244/mobilebnnnnnn_y12zgd.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              objectFit: "cover",
              zIndex: 0,
            }}
          >
            <source
              src="https://res.cloudinary.com/dk24unkwu/video/upload/v1753695280/IconsFallingAnimationV3_mwajn1.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        )}
      </>

      {/* Overlay content */}
      <Box
        mt={5}
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
          height: "100%",
          px: 2,
          direction: language === "ar" ? "rtl" : "ltr",
        }}
      >
        {/* Gradient Text Style */}
        <style>
          {`
            .gradient-text {
              background: linear-gradient(102.14deg, #4caf50ab -8.49%, #2D9CF4 13.91%, #422965 25.76%, #D80027 36.62%, #2196F3 43.92%, #59AF99 67.65%, #F7931A 86.98%, #F44336 95.32%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              color: black;
            
            }
          `}
        </style>

        <Typography
          data-aos="fade-down"
          variant="h1"
          sx={{ color: "#000", fontSize: "95px" }}
        >
          {translations[language]?.bannerTitle}{" "}
          {/* <span className="gradient-text"> */}
               <span>
            {translations[language]?.bannerTitle2}
          </span>
          <br />
          {translations[language]?.bannerSubtitle}
        </Typography>

        <Typography
          mt={{ xs: 2, sm: 5, md: 5 }}
          data-aos="fade-down"
          sx={{
            fontSize: { xs: "18px", md: "25px" },
            color: "rgba(0, 0, 0, 0.65)",
            fontWeight: 500,
            fontFamily: "SF Pro Display",
          }}
        >
          {translations[language]?.bannerDescription}
          <br /> {translations[language]?.bannerDescription2}
        </Typography>

        <Button
          component="a"
          href="https://portal.bbcorp.trade/auth/jwt/sign-up/"
          target="_blank"
          rel="noopener noreferrer"
          disableRipple
          sx={{
            mt: { xs: 2, sm: 4, md: 4 },
            background: "#000",
            color: "#fff",
            fontWeight: 500,
            padding: "12px 30px",
            borderRadius: "10px",
            textTransform: "capitalize",
            fontSize: "16px",
            "&:hover": {
              color: "#fff",
              
            },
          }}
        >
          {translations[language]?.openAccountButton}
        </Button>

        <Button
          sx={{
            mt: { xs: 2, sm: 7, md: 7 },
            background: "#2494c947",
            borderRadius: "50px",
            padding: "12px 24px",
            color: "#2494C9 !important",
            textTransform: "capitalize",
            fontFamily: "SF Pro Display",
            fontWeight: "500",
            display: "flex",
            fontSize: { xs: "14px", md: "16px" },
            alignItems: "center",
            gap: "8px",
            justifyContent: "center",
          }}
          disabled
        >
          <img
            src="/Images/Location.png"
            alt=""
            style={{
              width: isSmall ? "18px" : "20px",
              height: isSmall ? "18px" : "20px",
              objectFit: "contain", // or "cover"
            }}
          />{" "}
          {flagUrl ?? "Beirut"}
        </Button>
      </Box>
      {open &&
        <Cookies
          open={open}
          setOpen={setOpen}
          onClose={handleClose}
          onAcceptAll={handleAcceptAll}
          onModify={handleModify}
        />
      }
    </Box>
  );
};

export default Banner;
